// extracted by mini-css-extract-plugin
export default {"header":"app-organizations-OrganizationTeamTable-OrganizationTeamTable-module__PHX_xegobA27qquGxWlw"};